import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["sadad", "hasSadad", "sadadError"];
import React from "react";
var __jsx = React.createElement;
import useHelpers from "@hooks/useHelpers";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "@i18n";
import useButtonLoading from "@hooks/useButtonLoading";
import useApi from "@hooks/useApi";
import { api__getFinanceRemainingOrderDetails } from "@/apis/checkout/remainingPayments";
import Loader from "@componentsShared/Loader/Loader";
import RemainingPaymentComponent from "@/_MiniApps/RemainingPaymentComponent/RemainingPaymentComponent";
import MobileHeader1 from "@/_LayoutsRelated/mobileHeaders/mobileHeader1/MobileHeader1";
import Layout from "@/_LayoutsRelated/layout/Layout";
var FinanceRemainingPayment = function FinanceRemainingPayment() {
  var _financeRemainingOrde, _financeRemainingOrde2;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var location = useLocation();
  var state = location.state;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useParams = useParams(),
    order_uuid = _useParams.order_uuid;
  var buttonLoading = useButtonLoading();
  var _useApi = useApi([order_uuid], /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return api__getFinanceRemainingOrderDetails(order_uuid);
          case 1:
            return _context.a(2, _context.v);
          case 2:
            _context.p = 2;
            _t = _context.v;
            if (_t.name === "NotFound404Exception") {
              navigateToHard('/?ref=finance_remaining_payment_404');
            } else {
              navigateToHard('/?ref=finance_remaining_payment_500');
            }
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }))),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    data = _useApi2[2];
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  var _ref2 = data || {},
    sadad = _ref2.sadad,
    hasSadad = _ref2.hasSadad,
    sadadError = _ref2.sadadError,
    financeRemainingOrder = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    hideAppBanner: true,
    authenticationMsg: true,
    headHideLinks: true,
    hideOrangeHeadBtn: true,
    hasNavBar: true,
    mobileHasBack: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobileHeader1, {
      title: t("complete_payment_process", {
        ns: "web_common"
      }),
      buttonFunction: function buttonFunction() {
        navigateTo("/tracking-finance-details/".concat(id));
      },
      NoBack: !(state !== null && state !== void 0 && state.backFromSteps),
      className: "!bg-[#ebfdf3]"
    })
  }, Object.keys(financeRemainingOrder).length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "lg:after:content-[''] lg:after:fixed lg:after:top-0 lg:after:left-0 lg:after:w-full lg:after:h-full lg:after:bg-slate-50 lg:after:-z-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[567px] rounded-2xl border border-slate-300 bg-white shadow-lg mx-auto mt-14 mb-[150px] max-lg:w-full max-lg:m-0 max-lg:rounded-none max-lg:border-none max-lg:bg-transparent max-lg:shadow-none"
  }, /*#__PURE__*/React.createElement(RemainingPaymentComponent, {
    isFinance: true,
    buttonLoading: buttonLoading,
    order: financeRemainingOrder,
    sadad: sadad,
    hasSadad: hasSadad,
    sadadError: sadadError,
    banks: financeRemainingOrder === null || financeRemainingOrder === void 0 ? void 0 : (_financeRemainingOrde = financeRemainingOrder.paymentOptions) === null || _financeRemainingOrde === void 0 ? void 0 : _financeRemainingOrde.banks,
    enableAllPayments: financeRemainingOrder === null || financeRemainingOrder === void 0 ? void 0 : (_financeRemainingOrde2 = financeRemainingOrder.paymentOptions) === null || _financeRemainingOrde2 === void 0 ? void 0 : _financeRemainingOrde2.enabled,
    title: t("complete_payment_process", {
      ns: "web_common"
    }),
    id: financeRemainingOrder === null || financeRemainingOrder === void 0 ? void 0 : financeRemainingOrder.order_id,
    date: financeRemainingOrder === null || financeRemainingOrder === void 0 ? void 0 : financeRemainingOrder.date,
    updateSadadError: null
  }))) : null));
};
export default FinanceRemainingPayment;